export default __webpack_public_path__ + "static/media/user.5186307c.svg";